/* eslint-disable no-case-declarations */
import VueExcelXlsx from "vue-excel-xlsx";
import Vue from "vue";
import Vuex from "vuex";

const axios = require("axios");

axios.defaults.baseURL = process.env.VUE_APP_BASEAPI;
axios.interceptors.request.use(function(config) {
  config.headers.Authorization = localStorage.getItem("Token") || "";
  return config;
});

Vue.use(Vuex);
Vue.use(VueExcelXlsx);

export default new Vuex.Store({
  state: {
    status: "",
    Token: localStorage.getItem("Token") || "",
    customerid: null,
    id: null,
    name: "",
    role: "",
    username: "",
    ordlyd: null,
    // Husk å endre til 13 neste år, 2026
    manuallySelectedPlan: 13,
    plans: [],
    vernerunde: [],
  },
  getters: {
    GET_MANUALLYSELECTEDPLAN: (state) => state.manuallySelectedPlan,
    GET_PLANSFORTHISCUSTOMER: (state) => state.plans,
    GET_ORDLYD: (state) => state.ordlyd,
    GET_LOGIN_STATUS: (state) => state.status,
    GET_TOKEN: (state) => state.Token,
    GET_VERNERUNDE: (state) => state.vernerunde,
    GET_USER: (state) => {
      if (state.status == "success") {
        return {
          customerid: state.customerid,
          id: state.id,
          name: state.name,
          role: state.role,
          username: state.username,
        };
      } else {
        return null;
      }
    },
  },
  mutations: {
    set_plans(state, payload) {
      state.plans = payload;
    },
    set_manuallyselectedplan(state, payload) {
      if (
        payload == 0 ||
        state.plans.find((el) => el.id == payload).active == 1
      ) {
        state.manuallySelectedPlan = payload;
      } else {
        state.manuallySelectedPlan = payload;
      }
    },
    set_ordlyd(state, payload) {
      state.ordlyd = payload;
    },
    auth_request(state) {
      state.status = "loading";
    },
    auth_success(state, payload) {
      state.status = "success";
      state.Token = payload.Token;
      state.customerid = payload.customerid;
      state.id = payload.id;
      state.name = payload.name;
      state.role = payload.role;
      state.username = payload.username;
      localStorage.setItem("Token", state.Token);
    },
    auth_error(state) {
      state.status = "error";
    },
    logout(state) {
      state.status = "";
      state.Token = "";
      state.customerid = null;
      state.id = null;
      state.name = "";
      state.role = "";
      state.username = "";
      localStorage.removeItem("Token");
    },
  },
  actions: {
    SET_MANUALLYSELECTEDPLAN({ commit }, id) {
      return new Promise((resolve) => {
        commit("set_manuallyselectedplan", id);
        resolve();
      });
    },
    FETCH_ORDLYD({ commit }) {
      return new Promise((resolve, reject) => {
        axios
          .get("/ordlyd?mode=getcomputed")
          .then((resp) => {
            commit("set_ordlyd", resp.data);
            resolve();
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    SUBMIT_LOGIN({ commit }, userData) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post("/login", userData)
          .then((resp) => {
            if (resp && resp.data && resp.data.Transfer) {
              switch (resp.data.Transfer) {
                case "200":
                  commit("auth_success", resp.data.UserSignIn);
                  commit("set_ordlyd", resp.data.ordlyd);
                  resolve("Valid login, continuing");
                  break;
                case "401.u":
                  commit("auth_error");
                  reject("AUTH_ERROR");
                  break;
                case "401.p":
                  commit("auth_error");
                  reject("AUTH_ERROR");
                  break;
                default:
                  reject(`Unknown errorcode ${resp.data.Transfer}`);
              }
            }
          })
          .catch((err) => {
            commit("auth_error");
            localStorage.removeItem("Token");
            reject(err);
          });
      });
    },
    SUBMIT_LOGOUT({ commit }) {
      return new Promise((resolve) => {
        commit("logout");
        localStorage.removeItem("Token");
        resolve();
      });
    },
    SUBMIT_LOGIN_TOKEN({ commit }) {
      return new Promise((resolve, reject) => {
        commit("auth_request");
        axios
          .post("/logintoken", {})
          .then((resp) => {
            commit("auth_success", resp.data.UserSignIn);
            commit("set_ordlyd", resp.data.ordlyd);

            resolve(resp);
          })
          .catch((err) => {
            commit("auth_error");
            // localStorage.removeItem("Token");
            reject(err);
          });
      });
    },
    GET_PLANS() {
      return new Promise((resolve, reject) => {
        axios
          .get("/plans", {})
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GET_PLAN({}, id) {
      return new Promise((resolve, reject) => {
        axios
          .get("/plan/" + id, {})
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GET_VERNERUNDE({}, id) {
      return new Promise((resolve, reject) => {
        axios
          .get("/vernerunde/" + id, {})
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      })
    },
    GET_RESPONSES({}, id) {
      return new Promise((resolve, reject) => {
        axios
        .get("/vernerunde/" + id + "/responses", {})
        .then((resp) => {
          resolve(resp);
        })
        .catch((err) => {
          reject(err);
        })
      })
    },

    SUBMIT_VERNERUNDE_RESPONSE({}, ResponseData) {
      return new Promise((resolve, reject) => {
        axios
          .post("/vernerunde/" + ResponseData.guid, ResponseData)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GET_REPORT({}, id) {
      return new Promise((resolve, reject) => {
        axios
          .get("/report/" + id, {})
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GET_USER_PLAN({}, id) {
      return new Promise((resolve, reject) => {
        console.log('resp: ')
        axios
          // .get("/plan/" + id ? id : "")
          .get("/plan/" + id)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GET_CUSTOMERS() {
      return new Promise((resolve, reject) => {
        axios
          .get("/customers", {})
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GET_THIS_CUSTOMER({ state }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/customer/${state.customerid || 1}`, {})
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GET_THIS_CUSTOMER_OVERVIEW({ state, commit }) {
      return new Promise(async (resolve, reject) => {
        axios
          .get(
            `/custoverview/${state.customerid || 1}/${
              state.manuallySelectedPlan
            }`,
            {}
          )
          .then((resp) => {
            commit(
              "set_plans",
              resp.data.planning.filter((el) => el.deleted == 0)
            );
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GET_CUSTOMER({}, id) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/customer/${id}`, {})
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    ALTER_RESPONSE({}, ResponseData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/plan/${ResponseData.planningid}`, ResponseData)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    ALTER_PLAN({}, PlanData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/plan/${PlanData.planid}`, PlanData)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    ALTER_QUESTIONS({}, PlanData) {
      console.log('SENDING TO ALTER QUESTION')
      return new Promise((resolve, reject) => {
        axios
          .post(`/plan/${PlanData.planid}/vernerunde`, PlanData)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    ALTER_CUSTOMER({}, CustomerData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/customer/${CustomerData.customerid}`, CustomerData)
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    GET_CURRENT_ACTIVE_PLAN({ state }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/getcurrentactiveplan?customerId=${state.customerid || 1}`)
          .then((getActivePlan) => {
            resolve(getActivePlan.data);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
});
